






import Vue from "vue";
import { MAPS_CREDENTIALS } from "@/shared/global-values";

export default Vue.extend({
  props: {
    latitude: Number,
    longitude: Number,
  },
  data() {
    return {
      width: "100%",
      height: "300px",
      offsetWidth: 300,
    };
  },
  computed: {
    staticImageUrl(): string {
      const url: string = `${MAPS_CREDENTIALS.STATIC_IMAGE_API}`;

      const params: URLSearchParams = new URLSearchParams();
      params.set("key", MAPS_CREDENTIALS.API_KEY);
      params.set("center", `${this.latitude},${this.longitude}`);
      params.set("markers", `${this.latitude},${this.longitude}`);
      params.set("size", `${this.offsetWidth}x${this.offsetWidth}`);
      params.set("zoom", "15");

      return `${url}?${params.toString()}`;
    },
  },
  mounted() {
    const img: HTMLImageElement = this.$refs.map as HTMLImageElement;
    this.height = `${img.offsetWidth}px`;
    this.offsetWidth = img.offsetWidth;
  },
});
